"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtFullScreen = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtFullScreen = function SvgBtFullScreen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6H10.7999V7H9C7.89543 7 7 7.89543 7 9V10.8H6V9C6 7.34315 7.34315 6 9 6ZM6 17.2V19C6 20.6569 7.34315 22 9 22H10.7999V21H9C7.89543 21 7 20.1046 7 19V17.2H6ZM21 17.2V19C21 20.1046 20.1046 21 19 21H17.1999V22H19C20.6569 22 22 20.6569 22 19V17.2H21ZM22 10.8V9C22 7.34315 20.6569 6 19 6H17.1999V7H19C20.1046 7 21 7.89543 21 9V10.8H22Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 9.16699,
    y: 9.1665,
    width: 9.66667,
    height: 9.66667,
    rx: 0.5,
    stroke: "currentColor"
  }));
};

exports.SvgBtFullScreen = SvgBtFullScreen;